/**
 * @overview attachEventEmitable
 * @author Amir Absalyamov <mr.amirka@ya.ru>
 */

module.exports = require('./Emitter').wrap(require('./attachEvent'));
